import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromoCodeForm } from './PromoCodesForm/PromoCodesForm';
import { PromoCodesListItem } from './PromoCodesListItem/PromoCodesItem';
import { PromoCodeElementType } from 'src/AppState/PromoCodesState/PromoCodesState';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const PromoCodes = observer(() => {
    const { promoCodesState } = useAppStateContext();
    const { isLoading, promoCodesElementsList } = promoCodesState;
    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading}>
                        <Loader isActive={isLoading} />
                        {promoCodesElementsList.map((promoCode: PromoCodeElementType) => {
                            return (
                                <PromoCodesListItem
                                    key={`${promoCode.id}-${promoCode.promo_code.code}`}
                                    promoCode={promoCode}
                                />
                            );
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <PromoCodeForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
